import type { NormalizedBridgeChartData, NormalizedIndicatorSeries } from "../types/data";
import type { ChartLayout } from "../renderers/layout";
import type { PriceScale } from "../scales/priceScale";
import { xForIndex } from "../scales/timeScale";

export interface OverlayPoint {
  x: number;
  y: number;
  date: string;
  value: number;
}

export function mapOverlayPoints(
  series: NormalizedIndicatorSeries,
  data: NormalizedBridgeChartData,
  start: number,
  end: number,
  layout: ChartLayout,
  priceScale: PriceScale
): OverlayPoint[] {
  return series.points.flatMap(point => {
    const index = data.dateIndex[point.date];
    if (index === undefined || index < start || index > end) return [];
    return [{
      x: xForIndex(layout, start, end, index),
      y: priceScale.y(point.value),
      date: point.date,
      value: point.value
    }];
  });
}
